import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import kolReducer from './slices/kolSlice';
import emailBatchReducer from './slices/emailBatchSlice';
import emailCampaignReducer from './slices/emailCampaignSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    kol: kolReducer,
    emailBatch: emailBatchReducer,
    emailCampaign: emailCampaignReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch; 